import React from "react";
import * as Select from "@radix-ui/react-select";
import * as Icons from "../../assets/svgs/icons";

export type SelectionDropdownProps = {
  size?: "md" | "lg";
  options: string[];
  value?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

const HEIGHT_MAP = {
  md: "h-[40px]",
  lg: "h-[48px]",
};
const TEXT_SIZE_MAP = {
  md: "text-[12px]",
  lg: "text-[16px]",
};
const ChevronIcon = Icons.Chevron;

const SelectionDropdown: React.FC<SelectionDropdownProps> = ({
  size = "md",
  options,
  value,
  placeholder = "holder text",
  onChange,
  disabled,
}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Select.Root
      value={value}
      onValueChange={onChange}
      disabled={disabled}
      open={open}
      onOpenChange={setOpen}
    >
      <Select.Trigger
        className={`bg-white border border-[#eeeeee] border-solid box-border flex items-center justify-between px-[12px] rounded-[8px] w-[312px] ${HEIGHT_MAP[size]}`}
        aria-label={placeholder}
      >
        <Select.Value
          placeholder={
            <span
              className={`text-[#888888] ${TEXT_SIZE_MAP[size]} font-['Pretendard',sans-serif]`}
            >
              {placeholder}
            </span>
          }
        />
        <Select.Icon>
          <span
            className={`flex items-center justify-center transition-transform duration-200 ${
              open ? "rotate-[270deg]" : "rotate-90"
            }`}
          >
            <ChevronIcon width={24} height={24} />
          </span>
        </Select.Icon>
      </Select.Trigger>
      <Select.Content
        className={`bg-white box-border flex flex-col p-[8px] rounded-[8px] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)] w-[312px]`}
        position="popper"
      >
        {options.map((opt, idx) => (
          <Select.Item
            key={opt}
            value={opt}
            className={`box-border flex items-center px-[12px] py-[8px] rounded-[8px] w-full border-none outline-none focus:border-none focus:outline-none active:border-none active:outline-none cursor-pointer ${
              HEIGHT_MAP[size]
            } text-[#888888] text-[14px] font-['Pretendard',sans-serif] tracking-[-0.28px] ${
              value === opt ? "bg-[#f7f7f7]" : ""
            }`}
            style={{ boxShadow: "none" }}
          >
            <Select.ItemText>{opt}</Select.ItemText>
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default SelectionDropdown;
